
import Vue from 'vue'
/**
 * 获取公司设备列表
 */
export const findClinetInfoByPage = (params) => {
  return Vue.fetch.post('/apiv1/hybrid/findClinetInfoByPage ', params)
}



// WEBPACK FOOTER //
// ./src/services/hybridApi.js